import React from 'react';

const OrdersTableSkeleton: React.FC = () => (
  <div className="w-full animate-pulse">
    {/* Toolbar area */}
    <div className="flex w-full py-4 gap-4 items-center">
      <div className="w-full h-12 bg-neutral-200 dark:bg-neutral-700 rounded-3xl" />
      <div className="w-32 h-10 bg-neutral-200 dark:bg-neutral-700 rounded-3xl" />
      <div className="w-28 h-10 bg-neutral-200 dark:bg-neutral-700 rounded-3xl" />
    </div>
    {/* Table container */}
    <div className="w-full rounded-3xl overflow-hidden bg-surface-base">
      {/* Table head */}
      <div className="grid grid-cols-12 bg-surface-secondary">
        <div className="p-3 col-span-1">
          <div className="w-5 h-5 bg-neutral-200 dark:bg-neutral-700 rounded-3xl" />
        </div>
        <div className="p-3 col-span-4"><div className="h-4 w-24 bg-neutral-200 dark:bg-neutral-700 rounded-3xl" /></div>
        <div className="p-3 col-span-3"><div className="h-4 w-24 bg-neutral-200 dark:bg-neutral-700 rounded-3xl" /></div>
        <div className="p-3 col-span-3"><div className="h-4 w-24 bg-neutral-200 dark:bg-neutral-700 rounded-3xl" /></div>
        <div className="p-3 col-span-1"><div className="h-4 w-16 bg-neutral-200 dark:bg-neutral-700 rounded-3xl" /></div>
      </div>
      {/* Table rows */}
      <div className="divide-y divide-border-secondary">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="grid grid-cols-12 items-center">
            <div className="p-3 col-span-1"><div className="w-5 h-5 bg-neutral-200 dark:bg-neutral-700 rounded-3xl" /></div>
            <div className="p-3 col-span-4"><div className="h-4 w-3/4 bg-neutral-200 dark:bg-neutral-700 rounded-3xl" /></div>
            <div className="p-3 col-span-3"><div className="h-4 w-1/2 bg-neutral-200 dark:bg-neutral-700 rounded-3xl" /></div>
            <div className="p-3 col-span-3"><div className="h-4 w-1/3 bg-neutral-200 dark:bg-neutral-700 rounded-3xl" /></div>
            <div className="p-3 col-span-1"><div className="h-8 w-16 bg-neutral-200 dark:bg-neutral-700 rounded-3xl" /></div>
          </div>
        ))}
      </div>
    </div>
    {/* Pagination */}
    <div className="grid grid-cols-3 items-center gap-4 px-6 py-4">
      <div className='w-fit'><div className="h-9 w-24 bg-neutral-200 dark:bg-neutral-700 rounded-2xl" /></div>
      <div className="flex flex-row items-center justify-center w-fit mx-auto gap-2">
        {[...Array(5)].map((_, i) => (
          <div key={i} className={`h-9 w-9 ${i === 2 ? 'bg-neutral-300 dark:bg-neutral-600' : 'bg-neutral-200 dark:bg-neutral-700'} rounded-full`} />
        ))}
      </div>
      <div className='w-fit justify-self-end'><div className="h-9 w-24 bg-neutral-200 dark:bg-neutral-700 rounded-2xl" /></div>
    </div>
  </div>
);

export default OrdersTableSkeleton;
